import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { apiErrorMessage } from '../../../lib/api/apiErrorMessage';
import { DocumentPickerField } from './DocumentPickerField';
/** Pick one document and confirm. A failed confirm stays open with the reason shown. */ export function DocumentPickerDialog({ open, onOpenChange, title, confirmLabel, onConfirm }) {
    const [doc, setDoc] = useState();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState('');
    const close = (next)=>{
        if (pending) return;
        if (!next) {
            setDoc(undefined);
            setError('');
        }
        onOpenChange(next);
    };
    const submit = async ()=>{
        if (!doc || pending) return;
        setPending(true);
        setError('');
        try {
            await onConfirm(doc);
            setPending(false);
            close(false);
        } catch (e) {
            setPending(false);
            setError(apiErrorMessage(e, 'Could not link this document. Try again.'));
        }
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: close,
        size: "md",
        title: title,
        testId: Testids.registryDocuments.pickerDialog,
        footerProps: {
            confirmLabel,
            loadingLabel: 'Working…',
            loading: pending,
            confirmDisabled: !doc || pending,
            onConfirm: ()=>void submit(),
            onCancel: ()=>close(false),
            cancelProps: {
                disabled: pending
            }
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-[var(--space-3)]",
            children: [
                /*#__PURE__*/ _jsx(DocumentPickerField, {
                    label: "Document",
                    value: doc,
                    onChange: setDoc,
                    disabled: pending,
                    required: true
                }),
                error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                    tone: "danger",
                    children: error
                })
            ]
        })
    });
}
